import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa98874"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ItemLocation"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "M-Auto D-Flex W-100 P-Rel",
  style: {"gap":"1em"}
}
const _hoisted_4 = {
  key: 0,
  class: "D-Flex FlexColumn O-75 F_85em",
  style: {"justify-content":"start","text-align":"start"}
}
const _hoisted_5 = { class: "F1_25em F-Bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "F-Bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "F-Bold" }
const _hoisted_10 = { class: "F-Bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "F-Bold" }
const _hoisted_14 = {
  key: 2,
  class: "CookiesRowSplitter"
}
const _hoisted_15 = { class: "F-Bold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "F-Bold" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "F-Bold" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_22 = { class: "F-Bold" }
const _hoisted_23 = {
  key: 1,
  class: "D-Flex FlexColumn O-75 F_85em H-100",
  style: {"justify-content":"start","text-align":"start"}
}
const _hoisted_24 = { class: "F2em F-Bold" }
const _hoisted_25 = {
  key: 0,
  class: "BarColorsItems ReservedItems",
  style: 'inset-inline-end: 0%'
}
const _hoisted_26 = {
  class: "M-Auto D-Flex W-100 P-Rel",
  style: {"gap":"1em"}
}
const _hoisted_27 = {
  class: "D-Flex FlexColumn O-75 F_85em H-100",
  style: {"justify-content":"start","text-align":"start"}
}
const _hoisted_28 = { class: "F2em F-Bold" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "F-Bold F1_5em" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_ctx.SectionItems().length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SectionItems(), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.EditItem(item)),
            class: "D-Flex HoverGlow BGShade4",
            style: _normalizeStyle([{"min-width":"9em"}, `width: calc(${_ctx.SectionPercentage(item)}% - 2.2em);`])
          }, [
            _createElementVNode("span", _hoisted_3, [
              (!item.IsFlex)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.ItemCode), 1),
                    (item.ItemName && item.ItemName !== '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Translate('Name')), 1),
                          _createTextVNode(": "),
                          _createElementVNode("span", null, _toDisplayString(item.ItemName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_8,
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Translate('Brand')), 1),
                      _createTextVNode(": "),
                      _createElementVNode("span", null, _toDisplayString(item.BrandName), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Translate('Category')), 1),
                      _createTextVNode(": "),
                      _createElementVNode("span", null, _toDisplayString(item.CategoryName), 1)
                    ]),
                    _hoisted_11,
                    (item.IsPack)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate('Pack Size')), 1),
                          _createTextVNode(": "),
                          _createElementVNode("span", null, _toDisplayString(item.PackSize), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.IsPack)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.Translate('Available')), 1),
                      _createTextVNode(": "),
                      (item.IsPack)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.DecimalFixer(item.AvailableQuantity)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.DecimalFixer(item.TotalAvailableQuantity)) + ")", 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.Translate('Reserved')), 1),
                      _createTextVNode(": "),
                      (item.IsPack)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.DecimalFixer(item.ReservedQuantity)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.DecimalFixer(item.TotalReservedQuantity)) + ")", 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.Translate('Ordered')), 1),
                      _createTextVNode(": "),
                      (item.IsPack)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.DecimalFixer(item.OrderedQuantity)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.DecimalFixer(item.TotalOrderedQuantity)) + ")", 1)
                    ]),
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Specifications, (spec) => {
                      return (_openBlock(), _createElementBlock("span", { key: spec }, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.Translate(spec.Name)), 1),
                        _createTextVNode(": "),
                        _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (item.IsFlex)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.Translate('Flex')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_CookiesIcon, {
                Tooltip: _ctx.Translate('Delete'),
                onClick: _withModifiers(($event: any) => (_ctx.RemoveItemLocation($event, item)), ["stop"]),
                class: _normalizeClass([[item.OrderedQuantity + item.AvailableQuantity + item.ReservedQuantity === 0 ? '' : 'Disabled'], "SQR1em BlackWhite M-Auto DeleteItemLocationIcon"]),
                style: {"margin-inline-end":"0","z-index":"50","margin-top":"1em"},
                ID: ('Delete' as IconsIDs)
              }, null, 8, ["Tooltip", "onClick", "class", "ID"]),
              (_ctx.Access('Inventory_AvailableItems_Override') && !item.IsFlex)
                ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                    key: 2,
                    Tooltip: _ctx.Translate('Override Quantity'),
                    onClick: _withModifiers(($event: any) => (_ctx.LevelLocationsValue($event, item)), ["stop"]),
                    class: "SQR1_5em P-Abs BG1 OverrideButton",
                    ID: ('Leveling' as IconsIDs)
                  }, null, 8, ["Tooltip", "onClick", "ID"]))
                : _createCommentVNode("", true)
            ]),
            (item.ReservedQuantity > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25))
              : _createCommentVNode("", true),
            (item.OrderedQuantity > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "BarColorsItems OrderedItems",
                  style: _normalizeStyle('inset-inline-end:' + _ctx.OrderedVolume(item) + '%')
                }, null, 4))
              : _createCommentVNode("", true),
            (item.AvailableQuantity > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "BarColorsItems AvailableItems",
                  style: _normalizeStyle('inset-inline-end:' + _ctx.AvailableVolume(item) + '%')
                }, null, 4))
              : _createCommentVNode("", true)
          ], 12, _hoisted_2))
        }), 256)),
        (_ctx.SectionVolume && (_ctx.SectionVolume - _ctx.TotalVolume) > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "D-Flex BGShade1",
              style: _normalizeStyle([{"min-width":"9em","min-height":"16em","flex":"1"}, `min-width: max(calc(${(_ctx.SectionVolume - _ctx.TotalVolume) / _ctx.SectionVolume * 65}% - 8em), 9em); max-width: calc(${(_ctx.SectionVolume - _ctx.TotalVolume) / _ctx.SectionVolume * 100}%);`])
            }, [
              _createElementVNode("span", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Translate('Empty')) + ":" + _toDisplayString(_ctx.DecimalFixer(((_ctx.SectionVolume - _ctx.TotalVolume) / _ctx.SectionVolume) * 100, 2)) + "%", 1),
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.DecimalFixer((_ctx.SectionVolume - _ctx.TotalVolume))), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate('m3')), 1)
                ])
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}